import { getRequirementId, isRequirementRef } from '../../../../../util/userRequirement.util'

// A user requirement is just a UPN, so a "user:<upn>" field value already carries its own
// readable label — this builds a { "user:<upn>": upn } lookup for every such value found, so a
// review screen can show the UPN instead of the raw sentinel.
const buildUserRequirementOptionsMap = (values = []) =>
  Object.fromEntries(values.filter(isRequirementRef).map((value) => [value, getRequirementId(value)]))

export default buildUserRequirementOptionsMap
